function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1.649,22.379A.65.65,0,0,1,1,21.729V.648A.649.649,0,0,1,1.649,0h20.7A.649.649,0,0,1,23,.648V19.3a.649.649,0,0,1-1.3,0V1.3H2.3V21.081h7.838a.649.649,0,1,1,0,1.3ZM16.741,24a.666.666,0,0,0,.453-.182.638.638,0,0,0,.2-.467l0-3.25-.007-.088.071-.053a3.857,3.857,0,0,0,1.561-3.095A3.892,3.892,0,1,0,12.79,19.96l.062.066v3.325a.647.647,0,0,0,1.008.539l1.262-.841,1.262.841a.642.642,0,0,0,.357.11ZM14.4,21.97l-.252.168v-1.5l.195.039a3.875,3.875,0,0,0,1.557,0l.194-.039v1.5l-.252-.168A1.674,1.674,0,0,0,15.1,21.6C14.948,21.6,14.782,21.716,14.4,21.97Zm3.315-5.1a2.594,2.594,0,1,1-2.594-2.595A2.6,2.6,0,0,1,17.716,16.865Zm.649-11.514a.649.649,0,1,0,0-1.3H5.635a.649.649,0,1,0,0,1.3Zm0,4.054a.649.649,0,1,0,0-1.3H5.635a.649.649,0,1,0,0,1.3Z",
  transform: "translate(-1)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/private_company.03b84577.svg";
export { SvgComponent as ReactComponent };